import { mapGetters } from "vuex";
import moment from "moment";

export const steunInitiatief = {
  computed: {
    ...mapGetters(["labels", "gekozenInitiatief", "selectedId"])
  },
  methods: {
    toonOuderverklaring(gegevens, herkomst){
      var ouderverklaring = {};
      var marktonderzoek = gegevens.belangstellingsmetingMarktonderzoek;
      var steuninitiatief = gegevens.belangstellingsmetingOuderverklaring;
      var ingetrokken = gegevens.StatusExtern.statusExtern.toLowerCase() === "ingetrokken";

      if (marktonderzoek && !ingetrokken && (gegevens.datumtijdAanvraagIngediend == undefined || gegevens.datumtijdAanvraagIngediend == "")){
        ouderverklaring.titel = this.labels.MARKTONDERZOEK_INITIATIEF_TITEL;
        ouderverklaring.tekst = this.labels.MARKTONDERZOEK_INITIATIEF_TEKST;
        ouderverklaring.class = "notification notification--warning";
      }
      else{
        switch (gegevens.StatusExtern.statusExtern.toLowerCase()){
          case "gepubliceerd":
            if (steuninitiatief && herkomst == "detail" && (gegevens.datumtijdAanvraagIngediend == undefined || gegevens.datumtijdAanvraagIngediend == "")) {
              ouderverklaring.titel = this.labels.STEUN_INITIATIEF_TITEL;
              ouderverklaring.tekst = this.labels.STEUN_INITIATIEF_TEKST;
              ouderverklaring.class = "notification notification--warning";
            }
			if (gegevens.keuzePO && gegevens.keuzePO.toLowerCase() == "verzelfstandiging") {
				ouderverklaring.titel = this.labels.ZONDER_OUDERVERKLARING_TITEL;
				ouderverklaring.tekst = (this.labels['ZONDER_OUDERVERKLARING_UITLEG_'.concat(gegevens.keuzePO.toUpperCase())]);
				ouderverklaring.class = "notification notification--warning";
			}
			if (gegevens.keuzeVO && gegevens.keuzeVO.toLowerCase() == "splitsing") {
				ouderverklaring.titel = this.labels.ZONDER_OUDERVERKLARING_TITEL;
				ouderverklaring.tekst = (this.labels['ZONDER_OUDERVERKLARING_UITLEG_'.concat(gegevens.keuzeVO.toUpperCase())]);
				ouderverklaring.class = "notification notification--warning";
			}
            break;
          case "ingetrokken":
            ouderverklaring.titel = this.labels.INITIATIEF_INGETROKKEN_TITEL;
            ouderverklaring.tekst = this.labels.INITIATIEF_INGETROKKEN_TEKST;
            ouderverklaring.class = "notification notification--error";
            break;
          case "ingediend":
            ouderverklaring.titel = this.labels.INITIATIEF_WORDT_BEOORDEELD_TITEL;
            ouderverklaring.tekst = this.labels.INITIATIEF_WORDT_BEOORDEELD_TEKST;
            ouderverklaring.class = "notification notification--info";
            break;
          case "toegewezen":
          case "afgewezen":
          case "deel toegewezen":
            ouderverklaring.titel = this.labels.INITIATIEF_IS_BEOORDEELD_TITEL;
            ouderverklaring.tekst = this.labels.INITIATIEF_IS_BEOORDEELD_TEKST;
            ouderverklaring.class = "notification notification--info";
            break;
          case "buiten behandeling":
            ouderverklaring.titel = this.labels.INITIATIEF_BUITEN_BEHANDELING_TITEL;
            ouderverklaring.tekst = this.labels.INITIATIEF_BUITEN_BEHANDELING_TEKST;
            ouderverklaring.class = "notification notification--error";
            break;
          default:
        }
      }

      return ouderverklaring;
    },
    toonLinkStatusoverzicht1: function (gekozenInitiatief) {
      var toon = false;
      if  (gekozenInitiatief.StatusExtern.statusExtern.toLowerCase() == 'toegewezen' || 
          gekozenInitiatief.StatusExtern.statusExtern.toLowerCase() == 'afgewezen' || 
          gekozenInitiatief.StatusExtern.statusExtern.toLowerCase() == 'deel toegewezen')
        {
        toon = true
      }

      return toon
    },
    verzend(initiative){
      if (this.$matomo){
        this.$matomo.trackEvent("Initiatief-scholen", "button-initiatief-steunen", initiative.naam);
      }
      var waarde_1 = initiative.initiatiefId;
      var waarde_2 = initiative.sector;
      window.location.href = process.env.VUE_APP_GEEF_VERKLARING+waarde_1+"/"+waarde_2;
    },
    introTekst(tekst){
      var aTekst = tekst.split(" ");
      var aantalWoorden = aTekst.length <= 30 ? aTekst.length : 30;
      var intro = "";
      for (var i = 0; i < aantalWoorden; i++) {
        intro = intro.concat(aTekst[i].concat(" "));
      }
      return (aTekst.length <= 30) ? intro.trim() : intro.concat("...");
    },

    countWordsInText(text) {
      const splittedText = text.split(" ");
      return splittedText.length;
    }
  }
}


